import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getErrosList } from './erroGeralActions';
import { Bar } from 'react-chartjs-2';


var optionsGrafico = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
        padding: {
            top: 12,
            right: 18,
            bottom: 8,
            left: 8
        }
    },
    scales: {
        yAxes: [{
            ticks: {
                suggestedMin: 0,
                beginAtZero: true,
                precision: 0,
                fontColor: '#64748b',
                fontSize: 12,
                padding: 8
            },
            gridLines: {
                color: 'rgba(148, 163, 184, 0.20)',
                zeroLineColor: 'rgba(60, 141, 188, 0.35)',
                drawBorder: false
            },
            stacked: false
        }],
        xAxes: [{
            ticks: {
                fontColor: '#64748b',
                fontSize: 12,
                padding: 8,
                maxRotation: 0,
                autoSkip: false
            },
            gridLines: {
                color: 'rgba(226, 232, 240, 0.65)',
                drawBorder: false
            },
            stacked: false,
            categoryPercentage: 0.72,
            barPercentage: 0.86
        }]
    },
    tooltips: {
        enabled: true,
        mode: 'nearest',
        intersect: true,
        backgroundColor: 'rgba(15, 23, 42, 0.92)',
        titleFontStyle: '600',
        titleFontSize: 12,
        titleFontColor: '#f8fafc',
        bodyFontSize: 12,
        bodyFontColor: '#e2e8f0',
        borderColor: 'rgba(148, 163, 184, 0.35)',
        borderWidth: 1,
        cornerRadius: 8,
        xPadding: 12,
        yPadding: 10,
        caretPadding: 8
    },
    legend: {
        display: true,
        position: 'bottom',
        align: 'start',
        labels: {
            boxWidth: 14,
            padding: 14,
            fontColor: '#475569',
            fontSize: 12,
            usePointStyle: true
        }
    },
    title: {
        display: false
    }
}

var corGrafico = {
    cores: [],
    paleta: [
        '#2563eb',
        '#0ea5e9',
        '#f97316',
        '#22c55e',
        '#a855f7',
        '#ef4444',
        '#14b8a6',
        '#eab308',
        '#64748b',
        '#ec4899',
        '#84cc16',
        '#06b6d4',
        '#8b5cf6',
        '#f59e0b',
        '#10b981',
        '#3c8dbc'
    ],

    getCor: (indice) => {
        if (indice === corGrafico.cores.length) {
            let cor = corGrafico.paleta[indice % corGrafico.paleta.length];
            corGrafico.cores.push(cor);
        }
        return corGrafico.cores[indice];
    },

    getCorSuave: (indice) => {
        let cor = corGrafico.getCor(indice).replace('#', '');
        let r = parseInt(cor.substring(0, 2), 16);
        let g = parseInt(cor.substring(2, 4), 16);
        let b = parseInt(cor.substring(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, 0.82)`;
    }
}

class GraficoErroGeral extends Component {

    constructor(props) {
        super(props);

        this.dadosErroGeral = this.dadosErroGeral.bind(this);

        this.state = {
            listErros: []
        }
    }

    dadosErroGeral() {
        const erros = this.props.listErros || [];
        let dataset = [];
        let resultData = {};
        let resultErro = [];
        let dataLabels = [];
        let series = [];

        dataLabels = [];
        resultErro = [];
        for (const key in erros) {
            let serie = erros[key].mensagem,
                chave = erros[key].id + ' - ' + erros[key].descricao,
                quantidade = erros[key].quantidade;

            if (!resultErro[chave]) {
                resultErro[chave] = [];
            }
            resultErro[chave][serie] = quantidade;

            if (!series[serie]) {
                series[serie] = chave;
            }
        }

        for (let serie in series) {            
            let dados = [];

            for (let chave in resultErro) {
                
                if (resultErro[chave][serie]) {
                    dados.push(resultErro[chave][serie]);
                } else {
                    dados.push(0);
                }
    
                if (dataset.length === 0) {
                    dataLabels.push(chave);
                }
            }

            const indiceDataset = dataset.length;
            dataset.push({
                //stack: 'stack',
                label: serie,
                backgroundColor: corGrafico.getCorSuave(indiceDataset),
                borderColor: corGrafico.getCor(indiceDataset),
                hoverBackgroundColor: corGrafico.getCor(indiceDataset),
                borderWidth: 1,
                data: dados
            });

        }

        resultData = {
            labels: dataLabels,
            datasets: dataset
        };

        return resultData;
    }

    render() {
        return (
          <div className="erro-geral-chart-canvas">
            <Bar
                data={this.dadosErroGeral}
                height={400}
                width={800}
                options={optionsGrafico}
            />
          </div>
        );
    }
}

const mapStateToProps = state => ({ listErros: state.controladorErroGeralCad.listErros })
const mapDispatchToProps = dispatch => bindActionCreators({ getErrosList }, dispatch)
export default connect(null, mapDispatchToProps)(GraficoErroGeral)